
// SEO utility functions

export const generateSitemap = () => {
  const baseUrl = window.location.origin;
  const routes = [
    { url: '/', priority: 1.0, changefreq: 'daily' },
    { url: '/services', priority: 0.9, changefreq: 'weekly' },
    { url: '/ai-assistance', priority: 0.8, changefreq: 'weekly' },
    { url: '/appointments', priority: 0.8, changefreq: 'weekly' },
    { url: '/journal', priority: 0.8, changefreq: 'daily' },
    { url: '/medications', priority: 0.7, changefreq: 'weekly' },
    { url: '/period-tracking', priority: 0.7, changefreq: 'weekly' },
    { url: '/gestation-tracking', priority: 0.7, changefreq: 'weekly' },
    { url: '/contact', priority: 0.6, changefreq: 'monthly' },
    { url: '/about', priority: 0.5, changefreq: 'monthly' },
    { url: '/auth', priority: 0.4, changefreq: 'yearly' }
  ];

  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${routes.map(route => `  <url>
    <loc>${baseUrl}${route.url}</loc>
    <changefreq>${route.changefreq}</changefreq>
    <priority>${route.priority}</priority>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
  </url>`).join('\n')}
</urlset>`;

  return sitemap;
};

export const generateRobotsTxt = () => {
  const baseUrl = window.location.origin;
  
  return `User-agent: *
Allow: /

# Sitemap
Sitemap: ${baseUrl}/sitemap.xml

# Crawl-delay
Crawl-delay: 1

# Disallow certain paths
Disallow: /admin/
Disallow: /api/
Disallow: /*?*
Disallow: /auth/callback

# Allow important pages
Allow: /
Allow: /services
Allow: /ai-assistance
Allow: /appointments
Allow: /journal
`;
};

export const getPageSEOData = (pathname: string) => {
  const seoData: Record<string, any> = {
    '/': {
      title: 'Médicace - Plateforme de Santé Intelligente',
      description: 'Découvrez Médicace, votre plateforme de santé digitale complète. Téléconsultations, suivi médical, rappels médicaments, IA médicale et bien plus.',
      keywords: 'médicace, santé digitale, téléconsultation, plateforme médicale, suivi santé, IA médicale',
      type: 'website'
    },
    '/services': {
      title: 'Services Médicaux & Professionnels de Santé',
      description: 'Trouvez des professionnels de santé qualifiés près de chez vous. Prenez rendez-vous en ligne pour des consultations et soins médicaux.',
      keywords: 'services médicaux, professionnels santé, médecins, spécialistes, rendez-vous médical',
      type: 'service'
    },
    '/ai-assistance': {
      title: 'Assistant IA Médical - Conseils Santé Intelligents',
      description: 'Notre assistant IA médical vous aide à comprendre vos symptômes et vous guide vers les meilleurs soins. Technologie de pointe en santé.',
      keywords: 'IA médicale, assistant médical, intelligence artificielle santé, diagnostic IA, conseils médicaux',
      type: 'service'
    },
    '/appointments': {
      title: 'Gestion de Rendez-vous Médicaux',
      description: 'Gérez tous vos rendez-vous médicaux en un seul endroit. Rappels automatiques, historique des consultations et suivi personnalisé.',
      keywords: 'rendez-vous médical, gestion rdv, calendrier médical, rappels consultation',
      type: 'service'
    },
    '/journal': {
      title: 'Journal de Santé Personnel',
      description: 'Tenez un journal de santé complet avec suivi des symptômes, humeur, médicaments et analyses. Votre carnet de santé numérique.',
      keywords: 'journal santé, carnet santé numérique, suivi symptômes, dossier médical personnel',
      type: 'service'
    },
    '/medications': {
      title: 'Gestion des Médicaments & Rappels',
      description: 'Ne manquez plus jamais une prise de médicament. Rappels intelligents, interactions médicamenteuses et suivi d\'observance.',
      keywords: 'gestion médicaments, rappels médicaments, pilulier numérique, suivi traitement',
      type: 'service'
    },
    '/period-tracking': {
      title: 'Suivi du Cycle Menstruel',
      description: 'Suivez votre cycle menstruel avec précision. Prédictions personnalisées, symptômes et fertilité pour une meilleure santé féminine.',
      keywords: 'suivi cycle menstruel, règles, fertilité, santé féminine, calendrier menstruel',
      type: 'service'
    },
    '/gestation-tracking': {
      title: 'Suivi de Grossesse',
      description: 'Accompagnement personnalisé pendant votre grossesse. Suivi du développement, conseils semaine par semaine et carnet de maternité.',
      keywords: 'suivi grossesse, maternité, développement bébé, carnet grossesse, conseils enceinte',
      type: 'service'
    }
  };

  return seoData[pathname] || seoData['/'];
};
